import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Plus, X, CalendarDays, StickyNote, UserPlus } from 'lucide-react'
import { cn } from '@/lib/utils'

export function AddFab() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const menuItems = [
    {
      labelKey: 'fab.meeting',
      icon: CalendarDays,
      onClick: () => {
        setOpen(false)
        navigate('/log-interaction')
      },
    },
    {
      labelKey: 'fab.note',
      icon: StickyNote,
      onClick: () => {
        setOpen(false)
        navigate('/contacts')
      },
    },
    {
      labelKey: 'fab.contact',
      icon: UserPlus,
      onClick: () => {
        setOpen(false)
        navigate('/contacts/new')
      },
    },
  ] as const

  return (
    <>
      {/* FAB context menu */}
      <div
        className="fixed right-6 bottom-28 z-30 flex flex-col items-end gap-1"
        style={{ paddingBottom: 'var(--safe-area-bottom)' }}
      >
        {open && (
          <div className="bg-surface-container-highest/90 border-outline-variant/20 animate-in fade-in slide-in-from-bottom-2 mb-2 flex w-44 flex-col gap-1 rounded-2xl border p-2 shadow-2xl backdrop-blur-xl duration-200">
            {menuItems.map(({ labelKey, icon: Icon, onClick }) => (
              <button
                key={labelKey}
                onClick={onClick}
                className="hover:bg-primary/10 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
              >
                <Icon className="text-primary h-4 w-4" />
                <span>{t(labelKey)}</span>
              </button>
            ))}
          </div>
        )}

        {/* Main FAB button */}
        <button
          onClick={() => setOpen((prev) => !prev)}
          className={cn(
            'shadow-primary/20 flex h-14 w-14 items-center justify-center rounded-full shadow-lg',
            'from-primary to-primary-dim bg-gradient-to-br',
            'text-primary-foreground transition-transform active:scale-90',
          )}
          aria-label={t('nav.add')}
        >
          {open ? <X className="h-6 w-6" /> : <Plus className="h-6 w-6" />}
        </button>
      </div>

      {/* FAB backdrop */}
      {open && <div className="fixed inset-0 z-20 bg-black/40" onClick={() => setOpen(false)} />}
    </>
  )
}
